import { render, staticRenderFns } from "./OrcamentoAlerta.vue?vue&type=template&id=2d2a93a8&scoped=true"
import script from "./OrcamentoAlerta.vue?vue&type=script&lang=js"
export * from "./OrcamentoAlerta.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoAlerta.vue?vue&type=style&index=0&id=2d2a93a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a93a8",
  null
  
)

export default component.exports